import styled from "styled-components";

export const IconButton = styled.button`
  font-size: 18px;
  color: white;

  display: flex;
  justify-content: center;
  align-items: center;

  width: 32px;
  height: 32px;
  padding: 0 !important;
  border-radius: 4px;
  background-color: ${({ bg }) => `var(--${bg || "gray"}-color)`};

  cursor: pointer;

  transition: all 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);

  &:disabled {
    color: rgba(0, 0, 0, 0.25);
    cursor: no-drop;
    background-color: var(--gray-color);

    &:hover {
      color: white;
    }
  }
`;
